import React, { Component } from "react";
import "./GameScreen.scss";
import { Directions } from "../../utility/constants";
import { shake, shakeUp, shrink } from "../../utility/animation";
// import Flash2 from "../../static/icons/exit-tile-active.svg"
class GameScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalLights: props.metaData.totalLights,
      array: this.props.data,
      playerRowIndex: props.metaData.playerX,
      playerColIndex: props.metaData.playerY,
      numberOfLights: 0,
      currentDirection: props.metaData.direction,
      reset: false,
      index: props.metaData.index,
      moves: {
        movesArray: [],
        loopArray: [],
      },
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    // do things with nextProps.someProp and prevState.cachedSomeProp
    if (nextProps.metaData.index !== prevState.index) {
      return {
        array: nextProps.data,
        playerRowIndex: nextProps.metaData.playerX,
        playerColIndex: nextProps.metaData.playerY,
        currentDirection: nextProps.metaData.direction,
        index: nextProps.metaData.index,
        totalLights: nextProps.metaData.totalLights,

        // ... other derived state properties
      };
    } else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.metaData.index !== this.props.metaData.index) {
      this.setState({
        array: Array.from(this.props.data),
        playerRowIndex: this.props.metaData.playerX,
        playerColIndex: this.props.metaData.playerY,
        numberOfLights: 0,
        currentDirection: this.props.metaData.direction,
      });
    }
  }

  getTileImages = () => {
    return require(`static/icons/player-${this.state.currentDirection.toLowerCase()}.svg`);
  };

  setResetfalse = async () => {
    this.setState({ reset: false });
    await this.timeout(200);
  };

  forward = async (index = 1) => {
    const { playerColIndex, playerRowIndex, array } = this.state;
    switch (this.state.currentDirection) {
      case "LEFT": {
        if (
          array[playerRowIndex][playerColIndex - index] !== 0 &&
          array[playerRowIndex][playerColIndex - index] !== undefined
        ) {
          this.setState({
            playerColIndex: playerColIndex - index,
          });
          await this.checkDanger(playerRowIndex, playerColIndex - index, array);
        } else {
          shake();
          this.wrongDirectionMove();
        }
        break;
      }
      case "RIGHT": {
        if (
          array[playerRowIndex][playerColIndex + index] !== 0 &&
          array[playerRowIndex][playerColIndex + index] !== undefined
        ) {
          this.setState({
            playerColIndex: playerColIndex + index,
          });
          await this.checkDanger(playerRowIndex, playerColIndex + index, array);
        } else {
          shake();
          this.wrongDirectionMove();
        }
        break;
      }
      case "UP": {
        if (
          array[playerRowIndex - index] !== undefined &&
          array[playerRowIndex - index][playerColIndex] !== 0 &&
          array[playerRowIndex - index][playerColIndex] !== undefined
        ) {
          this.setState({ playerRowIndex: playerRowIndex - index });
          await this.checkDanger(playerRowIndex - index, playerColIndex, array);
        } else {
          shakeUp();
          this.wrongDirectionMove();
        }
        break;
      }
      case "DOWN": {
        if (
          array[playerRowIndex + index] !== undefined &&
          array[playerRowIndex + index][playerColIndex] !== undefined &&
          array[playerRowIndex + index][playerColIndex] !== 0
        ) {
          this.setState({ playerRowIndex: playerRowIndex + index });
          await this.checkDanger(playerRowIndex + index, playerColIndex, array);
        } else {
          shakeUp();
          this.wrongDirectionMove();
        }
        break;
      }
      default: {
        break;
      }
    }
  };

  clockwise = async () => {
    let i = Directions.indexOf(this.state.currentDirection);
    await this.setState({ currentDirection: Directions[i < 3 ? i + 1 : 0] });
  };

  aniticlockwise = async () => {
    let i = Directions.indexOf(this.state.currentDirection);
    await this.setState({ currentDirection: Directions[i > 0 ? i - 1 : 3] });
  };

  jump = async () => {
    this.forward(2);
    await this.timeout(200);
  };

  light = async () => {
    const { playerColIndex, playerRowIndex, array } = this.state;
    if (array[playerRowIndex][playerColIndex] === 2) {
      shrink();
      let temp = JSON.parse(JSON.stringify(array));
      temp[playerRowIndex][playerColIndex] = 3;
      this.setState({
        array: temp,
        numberOfLights: this.state.numberOfLights + 1,
      });
      await this.timeout(200);
      if (this.state.numberOfLights === this.props.metaData.totalLights) {
        await this.timeout(200);
        this.props.reset();
        this.setState({ reset: true });
        localStorage.setItem(
          `moves${this.props.metaData.index}`,
          JSON.stringify(this.state.moves)
        );
        this.props.goToNextLevel(this.state.moves);
      }
    }
  };

  wrongDirectionMove = () => {
    let wrongMoves = localStorage.getItem("wrongMoves")
      ? JSON.parse(localStorage.getItem("wrongMoves"))
      : {
          berrySquish: 0,
          forgotToTurn: 0,
        };
    wrongMoves.forgotToTurn++;
    localStorage.setItem("wrongMoves", JSON.stringify(wrongMoves));
  };

  checkDanger = async (playerRowIndex, playerColIndex, array) => {
    if (array[playerRowIndex][playerColIndex] === 1) {
      var audio = new Audio(require("../../static/sounds/berry-crushed.mp3"));
      !this.state.reset && audio.play();
      this.setState({ reset: true });
      await this.timeout(500);
      this.reset();
      let wrongMoves = localStorage.getItem("wrongMoves")
        ? JSON.parse(localStorage.getItem("wrongMoves"))
        : {
            berrySquish: 0,
            forgotToTurn: 0,
          };
      wrongMoves.berrySquish++;
      localStorage.setItem("wrongMoves", JSON.stringify(wrongMoves));
    } else {
      var audio1 = new Audio(require("../../static/sounds/jump.mp3"));
      audio1.volume = 0.05;
      audio1.play();
    }
  };

  reset = () => {
    this.setState({
      array: Array.from(this.props.data),
      playerRowIndex: this.props.metaData.playerX,
      playerColIndex: this.props.metaData.playerY,
      numberOfLights: 0,
      currentDirection: this.props.metaData.direction,
      reset: true,
    });
    this.props.reset();
  };

  moves = async (val, loopArray) => {
    switch (val) {
      case "FORWARD":
        await this.forward();
        break;
      case "CLOCKWISE":
        await this.clockwise();
        break;
      case "ANTICLOCKWISE":
        await this.aniticlockwise();
        break;
      case "JUMP":
        await this.jump();
        break;
      case "LIGHT":
        await this.light();
        break;
      case "PROCEDURE":
        await this.RunMoves(loopArray, loopArray, "PROCEDURE");
        break;
      default:
        break;
    }
  };

  timeout = (ms = 800) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  play = async (movesArray, loopArray) => {
    this.setState({
      moves: {
        movesArray,
        loopArray,
      },
    });
    await this.RunMoves(movesArray, loopArray, "MAIN");
  };
  RunMoves = async (movesArray, loopArray, type) => {
    let numberOfMoves = movesArray.length,
      i = 0;

    for (i = 0; i < numberOfMoves; i++) {
      if (this.state.reset) {
        break;
      }
      // console.log(movesArray[i],type,i)
      this.props.onMoveChange(movesArray[i], type, i);
      await this.moves(movesArray[i], loopArray, i);
      movesArray[i] !== "PROCEDURE" && (await this.timeout());
    }
  };

  render() {
    const { playerColIndex, playerRowIndex, array } = this.state;
    return (
      <table className="gamescreen-table" cellSpacing="0">
        <tbody>
          {array.map((row, rowIndex) => {
            return (
              <tr key={rowIndex}>
                {row.map((col, colIndex) => {
                  let classList = ["tile"],
                    playerBool =
                      playerRowIndex === rowIndex &&
                      playerColIndex === colIndex;
                  switch (col) {
                    case 0: {
                      classList.push("empty-gray");
                      classList.push("empty-gray2");
                      if (rowIndex === 0 && colIndex === 0)
                        classList.push("empty-gray-top-left");
                      if (rowIndex === 0 && colIndex === row.length - 1)
                        classList.push("empty-gray-top-right");
                      if (
                        rowIndex === array.length - 1 &&
                        colIndex === row.length - 1
                      )
                        classList.push("empty-gray-bottom-right");
                      if (rowIndex === array.length - 1 && colIndex === 0)
                        classList.push("empty-gray-bottom-left");
                      break;
                    }
                    case 1:
                      playerBool
                        ? classList.push("skull-with-player")
                        : classList.push("skull");
                      break;
                    case 2:
                      classList.push("toLit");
                      break;
                    case 3:
                      classList.push("lit");
                      break;
                    case 4:
                      classList.push("empty");
                      break;
                    default:
                      break;
                  }
                  return (
                    <td key={colIndex} className={classList.join(" ")}>
                      <div className="lit-child">
                        {/* <img src={Flash2} alt="flash2" /> */}
                      </div>
                      {playerBool && col !== 1 ? (
                        <img
                          src={this.getTileImages()}
                          alt="player"
                          className="character"
                        />
                      ) : (
                        ""
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}
export default GameScreen;
